<template>
  <div 
    class=" absolute top-10 right-10"
  >
    <fwb-toast 
      v-if="props.isActive" 
      :type="props.type" 
    > 
      {{ props.message }} 
    </fwb-toast>
  </div>
</template>
  
<script setup>
    import { FwbToast } from "flowbite-vue";
    import {  defineProps } from "vue";
    const props = defineProps({
    message: {
        type: String,
        required: true
    },
    type: {
        type: String,
        required: true
    },
    isActive:{
        type: Boolean,
        required: true
    }
    });

    

</script>